import {
	Accordion,
	AccordionSummary,
	AccordionDetails,
	Grid2 as Grid,
	Typography,
	Box,
	useTheme,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useStyles } from "./Invoice.styles";
import { OutstandingEdiInvoiceHeaderDetailsProps } from "./types";
import { CopyToClipboard } from "../CopyToClipboard/CopyToClipboard";
import ReceiveComments from "../Comment/ReceiveComments";
import { useCallback, useState } from "react";
import AsnButton from "../Asn/AsnButton";
import { InvoiceHeaderSummaryRows } from "./InvoiceSummaryRows";
export const OutstandingEdiInvoiceHeaderDetails = (props: OutstandingEdiInvoiceHeaderDetailsProps) => {
	const classes = useStyles();
	const {
		invoiceId,
		invoiceNumber,
		purchaseOrderNumber,
		purchaseOrderStatus,
		locationId,
		locationName,
		supplierName,
		invoiceType,
		invoiceDate,
		totalPriceInc,
		totalFreightInc,
		totalQty,
		isExpandedHeader,
		onExpandedButtonClick,
		receiveComments,
		asns,
	} = props;

	const [asnDetailsModalOpen, setAsnDetailsModalOpen] = useState(false);

	const onExpandClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		onExpandedButtonClick(!isExpandedHeader);
	};

	const onAsnDetailsModalOpen = useCallback(() => {
		setAsnDetailsModalOpen(true);
	}, []);

	const onAsnDetailsModalClose = useCallback(() => {
		setAsnDetailsModalOpen(false);
	}, []);

	const theme = useTheme();
	return (
		<>
			<Accordion expanded={isExpandedHeader}>
				<AccordionSummary
					expandIcon={<ExpandMoreIcon />}
					onClick={(event: React.MouseEvent<HTMLDivElement>) => onExpandClick(event as any)}
					aria-controls="invoiceheaderdetails-content"
					id="invoicerheaderdetails"
					className={classes.invoiceCollapsePanelSummary}
				>
					<Grid container alignItems="center" sx={{ width: "100%" }}>
						<Grid container alignItems="center" size="auto">
							<Typography variant="body2" color="textSecondary">
								PO No
								{purchaseOrderNumber && (
									<>
										<Typography component="span" variant="body2" display="inline" color="textPrimary">
											{" " + purchaseOrderNumber}
										</Typography>
										<CopyToClipboard text={purchaseOrderNumber} />
									</>
								)}
							</Typography>
						</Grid>
					</Grid>
				</AccordionSummary>
				<AccordionDetails>
					<Grid container>
						<Grid container size={8} spacing={1}>
							<Grid size={12}>
								<Typography className={classes.caption} variant="caption" color="textSecondary" display="inline">
									PO Status
								</Typography>
								<Typography className={classes.value} variant="body2">
									{purchaseOrderStatus ?? "N/A"}
								</Typography>
							</Grid>
						</Grid>
						<Grid container size={4} spacing={1}>
							<Grid size={12}>
								<Typography className={classes.caption} variant="caption" color="textSecondary" display="inline">
									Invoice Type
								</Typography>
								<Typography className={classes.value} variant="body2">
									{invoiceType}
								</Typography>
							</Grid>
						</Grid>
						<Grid container size={8} spacing={1}>
							<Grid size={12}>
								<Typography className={classes.caption} variant="caption" color="textSecondary">
									Invoice No
								</Typography>
								{invoiceNumber && (
									<Box display="flex" alignItems="center">
										<Typography className={classes.value} variant="body2">
											{invoiceNumber}
										</Typography>
										<CopyToClipboard text={invoiceNumber} />
									</Box>
								)}
							</Grid>
						</Grid>
						<Grid container size={4} spacing={1}>
							<Grid size={12}>
								<Typography className={classes.caption} variant="caption" color="textSecondary" display="inline">
									Total Cost Inc
								</Typography>
								<Typography className={classes.value} variant="body2">
									{`$${(totalPriceInc + totalFreightInc)?.toFixed(2)}`}
								</Typography>
							</Grid>
						</Grid>
						<InvoiceHeaderSummaryRows
							storeName={`${locationId} - ${locationName}`}
							supplierName={supplierName}
							totalPriceInc={totalPriceInc}
							totalFreightInc={totalFreightInc}
							totalQty={totalQty}
							invoiceDate={invoiceDate}
						/>
						{receiveComments && (
							<Grid container size={8} spacing={1}>
								<Grid size={12}>
									<ReceiveComments invoiceId={invoiceId} initialComments={receiveComments} />
								</Grid>
							</Grid>
						)}
						{asns.length > 0 && (
							<>
								<Grid container size={4} spacing={1}>
									<Grid size={12}>
										<AsnButton
											isOpen={asnDetailsModalOpen}
											asns={asns}
											fromLocationName={supplierName}
											toLocationId={locationId}
											toLocationName={locationName}
											onAsnDetailsModalOpen={onAsnDetailsModalOpen}
											onAsnDetailsModalClose={onAsnDetailsModalClose}
										/>
									</Grid>
								</Grid>
							</>
						)}
					</Grid>
				</AccordionDetails>
			</Accordion>
		</>
	);
};
